module.exports = __webpack_public_path__ + "static/img/sph_cp.872fa47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sph_cp.png
// module id = bNa1
// module chunks = 130